import React from 'react';

function NotFound() {
    return ( 
        <div className="container p-5 mb-5">
            <div className="row text-center">
       <h1 className="mt-5">404 NotFound</h1>
       <p>Sorry, the page you are looking for does not exist</p>
        </div>
        </div>
     );
}

export default  NotFound;